/* Menazz productkaarten (overgenomen van Theseca theseca-cards.js): label in de foto, swipen door
   alle productfoto's, pijltjes bij hover, kleurbolletje springt naar die foto.
   Ronde 4 (28-10-2026): swipen is JS-gestuurd. De fotostrook schuift niet meer zelf (overflow-x hidden,
   touch-action pan-y, geen scroll-snap), dus geen momentum meer op iPhone. Een veeg gaat altijd precies
   een foto verder of terug, ook bij een harde veeg. Een tik opent het product, verticaal scrollen blijft
   gewoon werken. Trackpad op computer: een zijwaartse veeg is ook precies een foto.
   01-11-2026 (snelheid): foto's in de strook krijgen srcset/sizes in plaats van een vaste breedte, alle slides lazy,
   en de eerste slide gebruikt dezelfde bestanden als de kaartfoto eronder (komt uit de cache). */
(function(){
  var st=document.createElement("style");
  st.textContent=".card-wrapper.has-th-swipe .card__heading a::after{pointer-events:none}.card-wrapper .card__media > .th-card-pct{z-index:6}"+
    "html body .card-wrapper .th-swipe__track{overflow-x:hidden!important;scroll-snap-type:none!important;touch-action:pan-y;-webkit-overflow-scrolling:auto}"+
    ".card-wrapper .th-swipe__slide{scroll-snap-align:none}";
  document.head.appendChild(st);
  function file(u){return String(u||"").split("?")[0].split("/").pop().replace(/_\d+x\d*\./,".")}
  function sized(u,w){u=String(u||"");if(/[?&]width=\d+/.test(u))return u.replace(/([?&])width=\d+/,"$1width="+w);return u+(u.indexOf("?")>-1?"&":"?")+"width="+w}
  function attr(s){return String(s||"").replace(/"/g,"&quot;")}
  function moveLabel(card){var pct=card.querySelector(".th-card-pct"),media=card.querySelector(".card__media");pct&&media&&pct.parentElement!==media&&media.appendChild(pct)}
  function build(card){
    moveLabel(card);
    if(card.dataset.thSwipe)return;
    var data=card.querySelector(".th-card-imgs");if(!data)return;
    var urls=(data.dataset.imgs||"").split("|").filter(Boolean);if(urls.length<2)return;
    var media=card.querySelector(".card__media");if(!media)return;
    card.dataset.thSwipe="1";
    var orig=media.querySelector("img"),sizes=(orig&&orig.getAttribute("sizes"))||"(min-width: 990px) 25vw, calc((100vw - 35px) / 2)";
    function imgTag(u,i){
      var src,srcset;
      if(i===0&&orig&&orig.getAttribute("srcset")&&file(orig.getAttribute("src"))===file(u)){src=orig.getAttribute("src");srcset=orig.getAttribute("srcset")}
      else{src=sized(u,360);srcset=[180,360,540,720].map(function(w){return sized(u,w)+" "+w+"w"}).join(", ")}
      return '<img src="'+attr(src)+'" srcset="'+attr(srcset)+'" sizes="'+attr(sizes)+'" alt="" loading="lazy" decoding="async" draggable="false">';
    }
    var href=data.dataset.url||"#",box=document.createElement("div");
    box.className="th-swipe";
    box.innerHTML='<div class="th-swipe__track">'+urls.map(function(u,i){return'<a class="th-swipe__slide" href="'+href+'" tabindex="-1" aria-hidden="'+(i?"true":"false")+'">'+imgTag(u,i)+'</a>'}).join("")+'</div><button type="button" class="th-swipe__arrow th-swipe__arrow--prev" aria-label="Previous image"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M15 5l-7 7 7 7"/></svg></button><button type="button" class="th-swipe__arrow th-swipe__arrow--next" aria-label="Next image"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 5l7 7-7 7"/></svg></button><div class="th-swipe__dots" aria-hidden="true">'+urls.map(function(u,i){return"<span"+(i?"":' class="is-on"')+"></span>"}).join("")+"</div>";
    media.insertBefore(box,media.querySelector(".th-card-pct"));
    card.classList.add("has-th-swipe");
    var track=box.querySelector(".th-swipe__track"),dots=box.querySelectorAll(".th-swipe__dots span");
    var n=urls.length,cur=0,w=function(){return Math.max(1,track.clientWidth)};
    function setDots(k){dots.forEach(function(d,j){d.classList.toggle("is-on",j===k)})}
    function go(i,instant){
      i=Math.max(0,Math.min(n-1,i));cur=i;setDots(i);
      var left=i*w();
      if(instant||!track.scrollTo){track.scrollLeft=left;return}
      try{track.scrollTo({left:left,behavior:"smooth"})}catch(e){track.scrollLeft=left}
    }
    card.__thGo=go;
    /* Pijltjes (computer, bij hover) */
    box.querySelector(".th-swipe__arrow--prev").addEventListener("click",function(e){e.preventDefault();e.stopPropagation();go(cur-1)});
    box.querySelector(".th-swipe__arrow--next").addEventListener("click",function(e){e.preventDefault();e.stopPropagation();go(cur+1)});
    /* Vegen met de vinger: richting bepalen, dan precies 1 foto */
    var sx=0,sy=0,st0=0,base=0,dx=0,mode=0,swiped=0,tid=null;
    function down(x,y){sx=x;sy=y;dx=0;mode=0;st0=Date.now();base=cur*w()}
    function move(x,y,e){
      var mx=x-sx,my=y-sy;
      if(mode===0){
        if(Math.abs(mx)<7&&Math.abs(my)<7)return;
        mode=Math.abs(mx)>Math.abs(my)?1:2; /* 1 = zijwaarts (foto's), 2 = verticaal (pagina) */
      }
      if(mode!==1)return;
      if(e&&e.cancelable)e.preventDefault();
      dx=mx;
      var max=(n-1)*w(),pos=base-dx;
      if(pos<0)pos=pos/3;else if(pos>max)pos=max+(pos-max)/3;
      track.scrollLeft=pos;
    }
    function up(){
      if(mode===1){
        var dt=Math.max(1,Date.now()-st0),v=Math.abs(dx)/dt,step=0;
        if(Math.abs(dx)>w()*0.18||(Math.abs(dx)>20&&v>0.3))step=dx<0?1:-1;
        swiped=Date.now();
        go(cur+step);
      }
      mode=0;
    }
    track.addEventListener("touchstart",function(e){if(e.touches.length!==1){mode=2;return}tid=e.touches[0].identifier;down(e.touches[0].clientX,e.touches[0].clientY)},{passive:true});
    track.addEventListener("touchmove",function(e){var t=e.touches[0];if(!t||t.identifier!==tid)return;move(t.clientX,t.clientY,e)},{passive:false});
    track.addEventListener("touchend",up,{passive:true});
    track.addEventListener("touchcancel",function(){if(mode===1)go(cur);mode=0},{passive:true});
    /* Pen of touch via pointer-events in browsers zonder touch-events */
    if(!("ontouchstart" in window)&&window.PointerEvent){
      var pid=null;
      track.addEventListener("pointerdown",function(e){if(e.pointerType==="mouse")return;pid=e.pointerId;down(e.clientX,e.clientY)});
      track.addEventListener("pointermove",function(e){if(e.pointerId!==pid)return;move(e.clientX,e.clientY,e)});
      track.addEventListener("pointerup",function(e){if(e.pointerId!==pid)return;pid=null;up()});
      track.addEventListener("pointercancel",function(){pid=null;if(mode===1)go(cur);mode=0});
    }
    /* Na een veeg geen klik doorlaten; een gewone tik opent het product */
    track.addEventListener("click",function(e){if(Date.now()-swiped<450){e.preventDefault();e.stopPropagation()}},true);
    /* Trackpad (zijwaarts): een gebaar = een foto */
    var wlock=0,wsum=0,wt=null;
    track.addEventListener("wheel",function(e){
      if(Math.abs(e.deltaX)<=Math.abs(e.deltaY))return;
      e.preventDefault();
      clearTimeout(wt);wt=setTimeout(function(){wlock=0;wsum=0},180);
      if(wlock)return;
      wsum+=e.deltaX;
      if(Math.abs(wsum)>25){wlock=1;go(cur+(wsum>0?1:-1))}
    },{passive:false});
    /* Bij draaien of andere breedte: op de huidige foto blijven */
    var rt;window.addEventListener("resize",function(){clearTimeout(rt);rt=setTimeout(function(){go(cur,true)},80)});
    /* Kleurbolletjes onder de foto: spring naar die foto */
    var files=urls.map(file);
    card.querySelectorAll(".th-card-sw [data-img]").forEach(function(sw){
      function pick(e){e.preventDefault();e.stopPropagation();var k=files.indexOf(file(sw.dataset.img));k>-1&&go(k);card.querySelectorAll(".th-card-sw > span").forEach(function(s){s.classList.toggle("is-active",s===sw)})}
      sw.addEventListener("click",pick);
      sw.addEventListener("keydown",function(e){(e.key==="Enter"||e.key===" ")&&pick(e)});
    });
  }
  function scan(root){(root||document).querySelectorAll(".card-wrapper").forEach(build)}
  function start(){scan();var q;new MutationObserver(function(list){for(var i=0;i<list.length;i++)if(list[i].addedNodes.length){clearTimeout(q);q=setTimeout(scan,50);return}}).observe(document.body,{childList:true,subtree:true})}
  document.readyState==="loading"?document.addEventListener("DOMContentLoaded",start):start();
})();
